import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { verifyEmail } from "../../api/auth";
import { authSelector } from "../../redux/slices/authSlice";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { isSuccess } = useSelector(authSelector);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(verifyEmail(token));
  }, [token]);

  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        navigate("/signin");
      }, 3000);
    }
  });
  return (
    <div
      style={{
        textAlign: "center",
        height: "100vh",
        backgroundColor: "#f2f5f8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <table
        role="presentation"
        style={{
          borderCollapse: "collapse",
          backgroundColor: "#f2f5f8",
          width: "100%",
        }}
      >
        <tr>
          <td align="center">
            <img src="https://i.ibb.co/Tm2wRKD/usend1.png" alt="" />
          </td>
        </tr>

        <tr>
          <td align="center">
            <div
              style={{
                maxWidth: "700px",
                margin: "30px",
                backgroundColor: "white",
                padding: "30px",
              }}
            >
              <h3
                style={{
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "34px",
                }}
              >
                Thank you for your trust in
                <span style={{ fontweight: "600" }}>U-Send!</span>
              </h3>
              <div
                style={{
                  textAlign: "center",
                  color: "#5b6aff",
                  margin: "30px 0px",
                  lineHeight: "24px",
                }}
              >
                <h3 style={{fontSize:"24px"}}>Your email has been verified successfully</h3>
              </div>
              <h4
                style={{
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Let's grow your business together.
              </h4>
              <Link to="/signin">
                <button
                  style={{
                    height: "40px",
                    width: "146px",
                    backgroundColor: "#5b6aff",
                    border: "1px solid #5b6aff",
                    bordeRadius: "20px",
                    color: "white",
                    margin: "30px 0",
                    cursor: "pointer",
                    borderRadius: "5px",
                  }}
                >
                  Log in
                </button>
              </Link>

              {/* <table style={{ borderCollapse: "collapse", width: "100%" }}>
                <tr style={{ bordertop: "50px solid white" }}>
                  <td align="left">
                    <img
                      src="https://i.ibb.co/L9DDKm5/logousend.png"
                      alt=""
                      style={{ height: "24px", width: "100px" }}
                    />
                  </td>
                  <td align="right" style={{ width: "70%" }}>
                    <span>
                      <iconify-icon
                        icon="akar-icons:twitter-fill"
                        style={{ color: "#91a4b8" }}
                        width="24"
                        height="24"
                      ></iconify-icon>
                    </span>
                    <span style={{ borderLeft: "25px solid white" }}>
                      <iconify-icon
                        icon="el:facebook"
                        style={{ color: "#91a4b8" }}
                        width="24"
                        height="24"
                      ></iconify-icon>
                    </span>
                    <span style={{ borderLeft: "25px solid white" }}>
                      <iconify-icon
                        icon="akar-icons:linkedin-box-fill"
                        style={{ color: "#91a4b8" }}
                        width="24"
                        height="24"
                      ></iconify-icon>
                    </span>
                  </td>
                </tr>
              </table> */}
            </div>
          </td>
        </tr>
      </table>
    </div>
  );
}
